<template>
  <TransferTable
    :leftTableDataTitle="leftTableDataTitle"
    :rightTableDataTitle="rightTableDataTitle"
    tableDataSelectTar="ccoId"
    fixedPropName="customerName"
    :isManualCheckAddData="true"
    @checkAddData="checkAddData"
    @addData="calc"
    @removeData="calc"
    ref="transferTable"
  />
</template>

<script>
import TransferTable from './components/transferTable/transfer';

const tableDataTitle = [
  { prop: 'customerName', label: '客户名称', fixed: true },
  { prop: 'sourceAddressDtl', label: '装货地址' },
  { prop: 'consignee', label: '收货方' },
  { prop: 'desAddressDtl', label: '目的地址' },
  { prop: 'quantityShipped', label: '数量' },
];
const rightTableDataTitle = JSON.parse(JSON.stringify(tableDataTitle));
rightTableDataTitle.unshift({
  prop: 'index', label: '序号', type: 'index', fixed: true,
});
export default {
  components: {
    TransferTable,
  },
  data () {
    return {
      leftTableDataTitle: tableDataTitle,
      rightTableDataTitle: rightTableDataTitle,
    };
  },
  methods: {
    setData (data) {
      this.$refs.transferTable.setData(data);
    },
    calc () {
      this.$emit('calc');
    },
    checkAddData (currentSelectedData, rightTableData) {
      // 如果右侧已有数据，则检测当前选择的数据中客户名称和右侧的客户名称是否一致，如果有其中一个不一致则不通过验证
      if (rightTableData.length) {
        const newTableData = currentSelectedData.filter((item) => rightTableData.some((info) => item.customerName !== info.customerName));
        if (newTableData.length) {
          this.$alert('一辆车上只能有一个客户的订单，请添加客户名称（为右侧列表中的客户名称）的订单', '温馨提示', {
            confirmButtonText: '确定',
          });
        } else {
          this.$refs.transferTable.addData();
        }
      } else {
        // 如果右侧没有数据，则检测当前选择的数据中客户名称是否一致，如果有其中一个不一致则不通过验证
        const customerName = currentSelectedData[0].customerName;
        const isPassCustomerNameCheck = currentSelectedData.every((item) => item.customerName === customerName);
        if (isPassCustomerNameCheck) {
          this.$refs.transferTable.addData();
        } else {
          this.$alert('一辆车上只能有同一个客户名称的订单，请重新选择', '温馨提示', {
            confirmButtonText: '确定',
          });
        }
      }
    },
    async sub () {
      const formData = await this.handleSubData();
      if (formData) {
        delete formData.rightTableData;
      }
      // 这个组件不需要提交任何数据，仅仅展示使用
      return {};
    },
    async cacheData () {
      const formData = await this.handleSubData();
      return formData;
    },
    async handleSubData () {
      const leftSearchData = await this.$refs.transferTable.getLeftTableBoxData();
      const rightTableData = await this.$refs.transferTable.getRightTableBoxData();
      return {
        leftSearchData,
        rightTableData,
      };
    },
    async init (data = {}) {
      // 从详情页面进来，重新设置右侧 table 和计算
      if (data.cityCustomerOrders && data.cityCustomerOrders.length) {
        this.$refs.transferTable.setRightTableBoxData(data.cityCustomerOrders);
        data.rightTableData = data.cityCustomerOrders;
        this.calc();
      }
      // 如果没有缓存右侧的数据，则清空两侧的内容
      if (!data.rightTableData) {
        this.$refs.transferTable.resetRightTableBoxData();
        this.$refs.transferTable.resetLeftTableBoxData();
      }
      // 如果左侧没有缓存数据，则清空左侧内容
      if (!data.leftSearchData) {
        this.$refs.transferTable.resetLeftTableBoxData();
      }
    },
  },
};
</script>

<style scoped lang="scss">
</style>
